/** UtilityEvents — standalone sidebar page for the UtilityAdmin: manage events. */
import Layout from "@/components/Layout";
import { CalendarHeart } from "lucide-react";
import AdminEvents from "@/pages/AdminEvents";

export default function UtilityEvents() {
  return (
    <Layout>
      <div className="space-y-6" data-testid="utility-events-page">
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-xl bg-rose-50 dark:bg-rose-900/30 text-rose-600 dark:text-rose-300 flex items-center justify-center">
            <CalendarHeart className="h-5 w-5" />
          </div>
          <div>
            <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-100" style={{ fontFamily: "Outfit" }}>Events</h1>
            <p className="text-sm text-slate-500 dark:text-slate-400">Add and manage school events.</p>
          </div>
        </div>
        <AdminEvents embedded />
      </div>
    </Layout>
  );
}
